/**
 * Session Refresh Service
 *
 * Manages session renewal tracking via localStorage.
 * Ensures the session is refreshed at least once every 24 hours
 * when the user is actively using the platform.
 */

const LAST_SESSION_REFRESH_KEY = 'aiodog_last_session_refresh';
const REFRESH_INTERVAL_MS = 24 * 60 * 60 * 1000; // 24 hours

/**
 * Checks if the session should be refreshed based on the last refresh timestamp.
 * Returns true if more than 24 hours have passed since the last refresh.
 */
export function shouldRefreshSession(): boolean {
  const lastRefresh = localStorage.getItem(LAST_SESSION_REFRESH_KEY);
  if (!lastRefresh) return true;

  const elapsed = Date.now() - parseInt(lastRefresh, 10);
  return elapsed >= REFRESH_INTERVAL_MS;
}

/**
 * Marks the current time as the last session refresh.
 * Should be called after successfully refreshing the session.
 */
export function markSessionRefreshed(): void {
  localStorage.setItem(LAST_SESSION_REFRESH_KEY, Date.now().toString());
}

/**
 * Clears the session refresh timestamp from localStorage.
 * Should be called on logout.
 */
export function clearSessionRefreshTimestamp(): void {
  localStorage.removeItem(LAST_SESSION_REFRESH_KEY);
}
